import { headerLogoStart } from './HeaderLogoStore.js';

export const updateHeaderLogoStart = (value) => headerLogoStart.update((oldValue) => value);
